'use client'

import Image from 'next/image'
import { Flex, Text, Modal, Button } from '@wiggot/web-components'
import WiggotXMonopolioLogo from '@/assets/svg/wiggot-x-monopolio.svg'
import Asterisk from '@/assets/svg/asterisk.svg'
import Reticle from '@/assets/svg/reticle.svg'
import BlueBlur from '@/assets/svg/blue-blur.svg'
import YellowThingy from '@/assets/svg/yellow-thingy.svg'

interface WiggotXMonopolioModalProps {
  isOpen: boolean
  onClose?: () => void
}

export const WiggotXMonopolioModal = ({
  isOpen,
  onClose
}: WiggotXMonopolioModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      className="w-[360px] h-[450px] border-[1px] !border-[#ebedf080] p-6 !bg-surface-bg-black relative overflow-hidden"
      onClose={onClose ? onClose : () => null}
      closeOnOutsideClick={false}
      enableBgBlur
    >
      <Flex dir="col" justify="between" items="center" className="h-full z-10">
        <Image src={WiggotXMonopolioLogo} alt="Wiggot-x-Monopolio" />
        <Flex dir="col" gap="gap-3" className="py-6">
          <Text className="text-[2rem] text-white font-[550]" align="center">
            El buscador más potente en Wiggot
          </Text>
          <Text className="text-sm text-white font-normal" align="center">
            Monopolio concentra toda la oferta inmobiliaria de México en un solo
            lugar y ahora puedes utilizarlo para encontrar justo lo que estás
            buscando.
          </Text>
        </Flex>
        <Button onClick={onClose} fullWidth>
          Comenzar a buscar
        </Button>
      </Flex>
      <Image
        src={Asterisk}
        alt="asterisk"
        className="absolute bottom-[-100px] z-[2] spin-animation"
      />
      <Image
        src={Reticle}
        alt="reticle"
        className="absolute top-0 z-[1] min-w-[834px]"
      />
      <Image
        src={BlueBlur}
        alt="blue-blur"
        className="absolute top-0 left-0 z-0"
      />
      <Image
        src={YellowThingy}
        alt="yellow-thingy"
        className="absolute top-[34%] right-[-6%] z-0"
      />
    </Modal>
  )
}
